import SingleChoiceQuestion from "./SingleChoiceQuestion";
import LadderQuestion from "./LadderQuestion/LadderQuestion";
import MultipleChoiceQuestion from "./MultipleChoiceQuestion";
import OpenListQuestion from "./OpenListQuestion";
import OpenQuestion from "./OpenQuestion";
import SelectTextQuestion from "./SelectTextQuestion";
import AttachmentAudio from "./AttachmentAudio";
import { useTranslation } from "react-i18next";
export default function QuestionRenderer({ q, value, onChange }) {
    const { t } = useTranslation();
    const questionType = q.questionType;
    const details = q.details || {};
    const lists = [];
    if (q.attachmentUrls) lists.push(q.attachmentUrls);
    const attachmentList = Array.from(
        new Set(
            lists
                .flat()
                .filter(Boolean)
        )
    );
    const Attachments = attachmentList.length > 0 ? (
        <div style={{ marginBottom: 8, display: "grid", gap: 8 }}>
            {attachmentList.map((url, i) => {
                const pairLabels = ["A", "B"]; // for pairs
                const computedLabel = attachmentList.length === 2
                    ? (q?.details?.attachmentLabel
                        ? t("audio.performance", { label: `${q.details.attachmentLabel}${pairLabels[i]}` })
                        : t("audio.recording", { index: i + 1 }))
                    : t("audio.recording", { index: i + 1 });
                return (
                    <AttachmentAudio
                        key={i}
                        id={`${q.questionID ?? "q"}-${i}`}
                        label={computedLabel}
                        relativeSrc={url}
                    />
                );
            })}
        </div>
    ) : null;

    if (questionType === "Ladder") {
        return (
            <>
                {Attachments}
                <LadderQuestion
                    details={details}
                    value={value}
                    onChange={onChange}
                    name={`q-${q.questionID ?? q.id ?? "ladder"}`}
                />
            </>
        );
    }
    if (questionType === "SC") {
        return (
            <>
                {Attachments}
                <SingleChoiceQuestion
                    options={details.options || []}
                    value={value}
                    onChange={onChange}
                    name={`q-${q.questionID ?? q.id ?? "sc"}`}
                    details={details}
                />
            </>
        );
    }
    if (questionType === "MC") {
        return (
            <>
                {Attachments}
                <MultipleChoiceQuestion options={details.options || []} value={value} onChange={onChange} details={details} />
            </>
        );
    }
    if (questionType === "Open") {
        return (
            <>
                {Attachments}
                <OpenQuestion answerType={details.answerType || "str"} value={value} onChange={onChange} details={details} />
            </>
        );
    }
    if (questionType === "SelectText") {
        return (
            <>
                {Attachments}
                <SelectTextQuestion details={details} value={value} onChange={onChange} />
            </>
        );
    }
    if (questionType === "OpenList") {
        // Build a compact signature to force remount when options change
        const sel = details.selectOptions || [];
        const sig = Array.isArray(sel)
            ? `${sel.length}:${String((sel[0] && (sel[0].value ?? sel[0])) ?? "")}:${String((sel[sel.length - 1] && (sel[sel.length - 1].value ?? sel[sel.length - 1])) ?? "")}`
            : "0:_:_";
        const compKey = `openlist-${q.questionID ?? q.id ?? "ol"}-${sig}`;
        return (
            <>
                {Attachments}
                <OpenListQuestion
                    key={compKey}
                    answerType={details.answerType || "str"}
                    value={value}
                    onChange={onChange}
                    details={details}
                />
            </>
        );
    }
    if (questionType === "Label") {
        // Text-only informational block; no input controls
        return (
            <>
                {Attachments}
                {/* No interactive controls for Label */}
            </>
        );
    }
    return null;
}